import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { User } from '../classes/user';
import { Settings } from '../settings';

@Injectable()

export class UserService {

  private contentHeadersJsonWithAuth: HttpHeaders;
  private contentHeadersJson: HttpHeaders;
  private baseUrl: string;

  constructor(
    private http: HttpClient
  ) {
    this.baseUrl = Settings.baseUrlBackend;
    this.ini();
  }

  // Métodos generales
  public ini(): void {
    this.contentHeadersJson = new HttpHeaders({'Content-Type': 'application/json'});
    const authorization = 'OAuth ' + localStorage.getItem('APPTenfieldPlayerAccessToken');
    this.contentHeadersJsonWithAuth = new HttpHeaders({'Content-Type':  'application/json', Authorization: authorization});
  }

  getUserSubscriptions(userIsLoggedIn): Observable<any> {
    this.ini();
    if (userIsLoggedIn) {
      const url = this.baseUrl + '/rest/core/servicios/obtenerSuscripcionesUsuario';
      const body = {};
      const options = { headers: this.contentHeadersJsonWithAuth };

      const request: Observable<any> = this.http.post(url, body, options);
      return request;
    } else {
      const observableUserPlans: Observable<any> = of({ErrorMessage: '', HasError: false, Suscripciones: []});
      return observableUserPlans;
    }
  }

  recoverPasswordStep1(userEmail: string): Observable<any> {
    const url = this.baseUrl + '/rest/core/servicios/recuperarContraseniaPaso1';
    const body = {
      Email: userEmail
    };
    const options = { headers: this.contentHeadersJson };

    const request: Observable<any> = this.http.post(url, body, options);
    return request;
  }

  recoverPasswordStep2(email: string, key: string, newPassword: string): Observable<any> {
    const url = this.baseUrl + '/rest/core/servicios/recuperarContraseniaPaso2';
    const body = {
      Email: email,
      Contrasenia: newPassword,
      KeyToChangePassword: key
    };
    const options = { headers: this.contentHeadersJson };

    const request: Observable<any> = this.http.post(url, body, options);
    return request;
  }

  changePassword(oldPassword: string, newPassword: string): Observable<any> {
    this.ini();
    const url = this.baseUrl + '/rest/core/servicios/cambiarContrasenia';
    const body = {
      ContraseniaActual: oldPassword,
      NuevaContrasenia: newPassword
    };
    const options = { headers: this.contentHeadersJsonWithAuth };

    const request: Observable<any> = this.http.post(url, body, options);
    return request;
  }

  createUser(user: User): Observable<any> {
    const url = this.baseUrl + '/rest/core/servicios/registrarUsuario';
    const body = {
      UsuarioData: null
    };
    const options = { headers: this.contentHeadersJson };

    const userToCreate = user.convertUserToBackendFormat();
    body.UsuarioData = userToCreate;

    const request: Observable<any> = this.http.post(url, body, options);
    return request;
  }

  updateGeneralData(user: User): Observable<any> {
    this.ini();
    const url = this.baseUrl + '/rest/core/servicios/editarInfoUsuario';
    const body = {
      UsuarioData: null
    };
    const options = { headers: this.contentHeadersJsonWithAuth };

    // Me aseguro de eliminarle el password por si vino sin querer, quiero que se guarden sólo datos generales
    delete user.UserPassword;
    const userToUpdate = user.convertUserToBackendFormat();

    body.UsuarioData = userToUpdate;

    const request: Observable<any> = this.http.post(url, body, options);
    return request;
  }

  getUserData(): Observable<any> {
    this.ini();
    const url = this.baseUrl + '/rest/core/servicios/obtenerInfoUsuario ';
    const body = {};
    const options = { headers: this.contentHeadersJsonWithAuth };

    const request: Observable<any> = this.http.post(url, body, options);
    return request;
  }

  subscribeToPlan(planId: string, fingerPrint: string): Observable<any> {
    this.ini();
    const url = this.baseUrl + '/rest/core/servicios/suscribirUsuarioAPlan';
    const body = {
      PlanId: planId,
      FingerPrint: fingerPrint
    };
    const options = { headers: this.contentHeadersJsonWithAuth };

    const request: Observable<any> = this.http.post(url, body, options);
    return request;
  }

  unsubscribeToPlan(planId: string): Observable<any> {
    this.ini();
    const url = this.baseUrl + '/rest/core/servicios/cancelarSuscripcionUsuarioAPlan';
    const body = {
      PlanId: planId
    };
    const options = { headers: this.contentHeadersJsonWithAuth };

    const request: Observable<any> = this.http.post(url, body, options);
    return request;
  }

  getAssociatedMeanOfPayment(): Observable<any> {
    this.ini();
    const url = this.baseUrl + '/rest/core/servicios/obtenerUsuarioMedioPago';
    const body = {};
    const options = { headers: this.contentHeadersJsonWithAuth };

    const request: Observable<any> = this.http.post(url, body, options);
    return request;
  }

  changeMeanOfPayment(planId: string, fingerPrint: string): Observable<any> {
    this.ini();
    const url = this.baseUrl + '/rest/core/servicios/agregarPlexoMedioPago';
    const body = {
      PlanId: planId,
      FingerPrint: fingerPrint
    };
    const options = { headers: this.contentHeadersJsonWithAuth };

    const request: Observable<any> = this.http.post(url, body, options);
    return request;
  }
}
